/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal, Label, Checkbox, Popup, List
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
//import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import api from '../../api';
//import userPic from '../../images/components/profile/profile_icon_1.png';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';
import WithRouter from '../Extensions/WithRouter';

class AssigningGroupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMAG: props.isOpenMAG,
      isOpenError: false,
      itemsChecked: false,
      searchKeyword: '',
      errSearch: false,
      isFocus: false,
      searchResults: [],
      selectedFilter: 'local',
      excludeIds: props.excludeIds || [],
      checkValues: [],
      activeIndex: '',
      memberPopup: false,
      memberList: [],
    };
    this.onChangeGroupFilter = this.onChangeGroupFilter.bind(this);
    this.handlesearchGroupChange = this.handlesearchGroupChange.bind(this);
    this.handlesearchGroup = this.handlesearchGroup.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleGroupCheckAll = this.handleGroupCheckAll.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.renderCloseMember = this.renderCloseMember.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMAG, excludeIds } = this.props;

    if (prevProps.isOpenMAG !== isOpenMAG) {
      this.setState({
        isOpenMAG,
        checkValues: [],
        itemsChecked: false,
        searchResults: [],
        selectedFilter: 'local',
        errSearch: false,
        isFocus: false,
        searchKeyword: '',
        memberPopup: false,
        excludeIds: excludeIds || [],
      }, () => {
        if (isOpenMAG) {
          this.searchGroup();
        }
      });
    }
  }

  handleGroupCheckAll() {
    const { itemsChecked, searchResults } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValues: [],
      });
    } else {
      const num = searchResults.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(searchResults[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValues: unique,
      });
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValues } = this.state;
    let newState;

    if (checkValues.indexOf(value) > -1) {
      newState = checkValues.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValues, value];
    }
    this.setState({
      checkValues: newState,
    });
  }

  handlesearchGroup(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          searchResults: [],
        },
        () => {
          this.searchGroup();
          setTimeout(() => {
            this.setState({
              isFocus: false,
            });
          }, 1500);
        }
      );
    }
  }

  handlesearchGroupChange(e) {
    this.setState({
      searchKeyword: e.target.value,
    });
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  onSubmit() {
    const { checkValues, searchResults } = this.state;

    if (checkValues.length === 0) {
      this.setState({
        isOpenError: true,
      });
      return false;
    }

    const selectedArr = searchResults.filter((item) => {
      return checkValues.indexOf(item.id) > -1;
    });

    let i = 0;
    for (i; i < selectedArr.length; i++) {
      selectedArr[i].type = 'group';
    }

    this.setState({
      isOpenMAG: false,
    });
    this.props.closeModal();
    this.props.completeCallback(selectedArr);
  }

  onChangeGroupFilter = (e) => {
    let newValue;
    switch (true) {
    case e.target.text.indexOf('Local') > -1:
      newValue = 'local';
      break;
    case e.target.text.indexOf('LDAP') > -1:
      newValue = 'ldap';
      break;
    default:
      newValue = 'local';
      break;
    }
    this.setState(
      {
        selectedFilter: newValue,
        searchResults: [],
      },
      () => {
        this.searchGroup();
      }
    );
  };

  closeModal() {
    this.setState({
      isOpenMAG: false,
    });
    this.props.closeModal();
  }

  closeErrorModal() {
    this.setState({
      isOpenError: false,
    });
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        searchResults: [],
      },
      () => {
        this.searchGroup();
      }
    );
  }

  searchGroup() {
    const { searchKeyword, excludeIds, selectedFilter } = this.state;
    api
      .searchGroup({
        search: searchKeyword,
        filter: selectedFilter,
        exclude_ids: excludeIds,
      })
      .then((response) => {
        if (response.count === 0) return;

        this.setState({
          searchResults: response.response,
        });
      });
  }

  renderMember(id) {
    api
      .getSGroupMemberDetail(id)
      .then((response) => {
        const data = response.response;
        this.setState({
          memberPopup: true,
          activeIndex: id,
          memberList: data.member_list,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  renderCloseMember() {
    this.setState({
      memberPopup: false,
      activeIndex: '',
      memberList: [],
    });
  }

  render() {
    const {
      selectedFilter, searchKeyword, errSearch, isFocus, searchResults, itemsChecked, checkValues, activeIndex
    } = this.state;
    const { translate } = this.props;

    return (
      <Modal open={this.state.isOpenMAG} onClose={this.closeModal}>
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="popup_scroll">
              <div className="setting_popup_header">
                <h2 className="popup_name">
                  {translate('modal.title.assigning_group')}
                  {/**<em>Project Name</em>*/}
                </h2>
                <a
                  className="popup_close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="setting_popup_tab">
                <a
                  className={selectedFilter === 'local' ? 'active' : null}
                  style={{ cursor: 'pointer' }}
                  onClick={this.onChangeGroupFilter}
                  onKeyUp={this.onChangeGroupFilter}
                >
                  {translate('modal.title.local')}
                </a>
                <a
                  className={selectedFilter === 'ldap' ? 'active' : null}
                  style={{ cursor: 'pointer' }}
                  onClick={this.onChangeGroupFilter}
                  onKeyUp={this.onChangeGroupFilter}
                >
                  {translate('modal.title.ldap')}
                </a>
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    <div className="search_box">
                      <span className="search_icon">
                        <img src={searchIcon} alt="" />
                      </span>
                      <input
                        type="text"
                        value={searchKeyword}
                        placeholder={translate('settings.list.group_name')}
                        onChange={this.handlesearchGroupChange}
                        onKeyPress={this.handlesearchGroup}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                      />
                      <a
                        className="reset_icon"
                        onClick={this.clearSearch}
                        onKeyUp={this.clearSearch}
                      >
                        x
                      </a>
                      {errSearch && (
                        <Label basic color="red" pointing>
                          {translate('contents_header.message.least_two_required_to_search')}
                        </Label>
                      )}
                      {isFocus && <Label pointing>{translate('settings.list.group_name')}</Label>}
                    </div>
                  </div>
                  <div className="setting_popup_content">
                    <div className="table_wrap table_type_3" style={{ height: '322px' }}>
                      <Scrollbars>
                        <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                          <colgroup>
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '70%' }} />
                            <col style={{ width: '25%' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <th>
                                <Checkbox
                                  checked={itemsChecked}
                                  onChange={this.handleGroupCheckAll}
                                />
                              </th>
                              <th>{translate('settings.list.group_name')}</th>
                              <th>{translate('settings.list.group_member')}</th>
                            </tr>
                            {
                              searchResults.length !== 0 ? (
                                searchResults.map((result) => {
                                  return (
                                    <tr key={uuidv4()}>
                                      <td>
                                        <Checkbox
                                          value={result.id}
                                          checked={checkValues.indexOf(result.id) > -1}
                                          onChange={this.handleCheckChange}
                                        />
                                      </td>
                                      <td className="strong">{result.name}</td>
                                      <td className="strong" style={{ textAlign: 'center' }}>
                                        {
                                          result.member_count !== 0 ? (
                                            <Popup
                                              trigger={<span style={{ cursor: 'pointer' }}>{result.member_count}</span>}
                                              on="click"
                                              hideOnScroll
                                              position="bottom left"
                                              open={this.state.memberPopup && activeIndex === result.id}
                                              onOpen={() => {
                                                return this.renderMember(result.id);
                                              }}
                                              onClose={this.renderCloseMember}
                                            >
                                              <List>
                                                {
                                                  this.state.memberList.map((list) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="user" />
                                                        <List.Content>{list}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List>
                                            </Popup>
                                          ) : (
                                            <span>
                                              {result.member_count}
                                            </span>
                                          )
                                        }
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : null
                            }
                          </tbody>
                        </table>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.onSubmit}
                    onKeyUp={this.onSubmit}
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpenError} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('settings.message.select_one_group')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(AssigningGroupModal)));
